import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { Observable, throwError } from 'rxjs';
import { Route } from '@angular/compiler/src/core';
import { environment } from 'src/environments/environment';
import { LoginRequest } from 'src/app/auth/models/login-request';
import { AuthService } from 'src/app/auth/auth.service';
import { catchError } from 'rxjs/operators';
import { HelpersService } from 'src/core/services/helpers.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private helpersService: HelpersService
  ) { }

  private formatUrlWithParams(baseUrl: string, params: Record<string, string | undefined>): string {
    const urlParams = Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== null && value !== '')
      .map(([key, value]) => `${key}=${encodeURIComponent(value!)}`)
      .join('&');
    return urlParams ? `${baseUrl}?${urlParams}` : baseUrl;
  }

  private buildDecodedRedirectUri(baseUrl: string, path: string | undefined, additionalParams: Record<string, string | undefined>): string {
    const subUrlParams = Object.entries(additionalParams)
    .filter(([_, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => `${key}=${encodeURIComponent(value!)}`)
    .join('&');
  const subUrl = path ? `${baseUrl}${path}` : baseUrl;
  return subUrlParams ? `${subUrl}?${subUrlParams}` : subUrl;
}

private isRedirecting = false;

  canActivate(route: Route): Observable<boolean> | boolean {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('auth_token');
    const fromDashboard = urlParams.get('dashboard');

    const id_risorsa = urlParams.get('id_risorsa');
    const mode = urlParams.get('mode');
    const index = urlParams.get('index');

    const idRisorsaPath = id_risorsa ? `id_risorsa=${encodeURIComponent(id_risorsa)}` : '';
    const modePath = mode ? `mode=${encodeURIComponent(mode)}` : '';

    if (this.helpersService.accessToken) {
      if (token) {
        // se auth_token è nei queryparam, rimuovere i queryparam tranne id_risorsa e mode (solo se id_risorsa presente)
        const currentUrl = window.location.href;
        const baseUrl = `${window.location.origin}${window.location.pathname}`;
        let updatedUrl = baseUrl;

        const paramsArray = [];
        if (id_risorsa) {
          paramsArray.push(`id_risorsa=${encodeURIComponent(id_risorsa)}`);
        }
        if (mode) {
          paramsArray.push(`mode=${encodeURIComponent(mode)}`);
        }

        if (index) {
          paramsArray.push(`index=${encodeURIComponent(index)}`);
        }
        
        if (paramsArray.length > 0) {
          updatedUrl += '?' + paramsArray.join('&');
        }

        if (currentUrl !== updatedUrl) {
          window.location.replace(updatedUrl);
        }
      }
      return true;
    } else {
      if (token) {
        // validare il nuovo token e salvare in storage
        const request = new LoginRequest({ token });
        this.authService.login(request).subscribe(
            (response) => {
              this.helpersService.saveToLocalStorage(response);
              this.helpersService.startRefreshInterval();

              // Passo mode solo se id_risorsa è presente
              const redirectParams: Record<string, string | undefined> = {};
              if (id_risorsa) {
                redirectParams['id_risorsa'] = id_risorsa;
              }
              if (mode) {
                redirectParams['mode'] = mode;
              }
              if (index) {
                redirectParams['index'] = index;
              }
             
              const redirectUri = this.buildDecodedRedirectUri(
                  environment.redirectSSOUrl,
                  environment.controls.unique_environment
                      ? this.helpersService.config.data.route
                      : undefined,
                  redirectParams
              );

              this.isRedirecting = true;
              window.location.replace(redirectUri);
              return true;
            }),
            catchError((error) => {
              this.helpersService.handleError(error);
              return throwError(error);
            });
        return true;
      } else {
        if (fromDashboard) {
          const redirectParams: string[] = [];

          if (id_risorsa) {
            redirectParams.push(`id_risorsa=${encodeURIComponent(id_risorsa)}`);
            if (mode) {
              redirectParams.push(`mode=${encodeURIComponent(mode)}`);
            }
            if (index) {
              redirectParams.push(`index=${encodeURIComponent(index)}`);
            }

          }

          const subPath = environment.controls.unique_environment
              ? this.helpersService.config.data.route
              : '';

          const redirectUri = `${environment.redirectSSOUrl}${subPath}${redirectParams.length > 0 ? '?' + redirectParams.join('&') : ''}`;


          const samlLoginUrl = `${environment.apiUrl}/api2/saml/login?redirect_uri=${encodeURIComponent(redirectUri)}`;


          window.location.replace(samlLoginUrl);
          return false;
        }
        else {
          window.location.replace(`${environment.requestsLinkUrl}${environment.funnelHome}`);
        }
        return false;
      }
    }
  }
}
